/* Belle et Blanc appointment booking form (121 Group).
 * 14/09/2026 CRO revision: four short steps (type, details, date and time, confirm),
 * inline field errors, browser-side draft resume, draft id + progress beacons for the
 * dashboard's Abandoned Bookings page. Attribution capture, Stripe fee flow and the
 * confirmation analytics are unchanged from the 11/09 build.
 */
(function () {
  "use strict";
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const fmtTime = (ms) => new Date(ms).toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit", hour12: true });
  const fmtDateLong = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  const fmtDow = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-AU", { weekday: "short" });
  const fmtDay = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-AU", { day: "numeric" });
  const fmtMonth = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-AU", { month: "short", year: "numeric" });
  function isoAdd(iso, days) {
    const d = new Date(iso + "T00:00:00");
    d.setDate(d.getDate() + days);
    return d.toISOString().slice(0, 10);
  }
  function todayIso() {
    return new Date().toISOString().slice(0, 10);
  }
  const cleanName = (s) => (s || "").replace(/^\*+/, "").trim();
  const DRAFT_KEY = "beb_draft";
  const DRAFT_TTL_MS = 14 * 24 * 3600 * 1000;

  document.addEventListener("DOMContentLoaded", () => {
    $$("[data-beb-appointment]").forEach(initForm);
  });

  function initForm(root) {
    // ---------- attribution (unchanged) ----------
    function bebCookie(n) {
      const m = document.cookie.match(new RegExp("(?:^|; )" + n.replace(/[.$?*|{}()\[\]\\\/\+^]/g, "\\$&") + "=([^;]*)"));
      return m ? decodeURIComponent(m[1]) : "";
    }
    function bebFirstTouch() {
      const k = "beb_attr";
      let cur = null;
      try { cur = JSON.parse(localStorage.getItem(k) || "null"); } catch (e) {}
      const q = new URLSearchParams(location.search), touch = {};
      ["gclid", "wbraid", "gbraid", "fbclid", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((p) => {
        if (q.get(p)) touch[p] = q.get(p).slice(0, 200);
      });
      if (document.referrer && document.referrer.indexOf(location.hostname) < 0) touch.referrer = document.referrer.slice(0, 300);
      touch.landing = location.pathname;
      touch.ts = Date.now();
      if (!cur || touch.gclid || touch.wbraid || touch.gbraid || touch.fbclid || touch.utm_source) {
        try { localStorage.setItem(k, JSON.stringify(touch)); } catch (e) {}
        cur = touch;
      }
      return cur || {};
    }
    function bebAttribution() {
      const ft = bebFirstTouch(), gclaw = bebCookie("_gcl_aw"), gcl = gclaw.split(".")[2] || "";
      return {
        gclid: ft.gclid || gcl || "", wbraid: ft.wbraid || "", gbraid: ft.gbraid || "", fbclid: ft.fbclid || "",
        fbc: bebCookie("_fbc"), fbp: bebCookie("_fbp"), gcl_au: bebCookie("_gcl_au"), ga: bebCookie("_ga"),
        utm_source: ft.utm_source || "", utm_medium: ft.utm_medium || "", utm_campaign: ft.utm_campaign || "",
        referrer: ft.referrer || "", landing: ft.landing || "", first_touch_ts: ft.ts || null, page: location.href.slice(0, 300),
      };
    }

    // ---------- draft persistence (resume + abandoned tracking) ----------
    function newDraftId() {
      try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID().toLowerCase(); } catch (e) {}
      return "d-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
    }
    function loadDraft() {
      try {
        const d = JSON.parse(localStorage.getItem(DRAFT_KEY) || "null");
        if (!d || !d.id || !d.ts || Date.now() - d.ts > DRAFT_TTL_MS || d.done) return null;
        return d;
      } catch (e) { return null; }
    }
    function saveDraft(patch) {
      const cur = loadDraft() || { id: state.draftId || newDraftId() };
      const next = Object.assign(cur, patch || {}, { ts: Date.now() });
      state.draftId = next.id;
      try { localStorage.setItem(DRAFT_KEY, JSON.stringify(next)); } catch (e) {}
      return next;
    }
    function clearDraft() {
      try { localStorage.removeItem(DRAFT_KEY); } catch (e) {}
    }
    function beacon(step, extra) {
      const body = JSON.stringify(Object.assign({
        draft_id: state.draftId, step: step,
        type_id: state.type ? state.type.id : null,
        selected_date: state.date || null,
        slot_start_ms: state.slot ? state.slot.start_ms : null,
        contact_id: state.contactId || null,
        landing: (bebFirstTouch().landing || "").slice(0, 200),
      }, extra || {}));
      try {
        // text/plain keeps it a simple request (no preflight), and sendBeacon survives a closed tab.
        if (navigator.sendBeacon && navigator.sendBeacon(api("/progress"), new Blob([body], { type: "text/plain" }))) return;
      } catch (e) {}
      try { fetch(api("/progress"), { method: "POST", body: body, keepalive: true, credentials: "omit", headers: { "Content-Type": "text/plain" } }).catch(() => {}); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: "beb_booking_step", beb_step: step }); } catch (e) {}
    }

    // ---------- state + elements ----------
    const endpointBase = (root.dataset.endpointBase || "").replace(/\/$/, "");
    const api = (path) => `${endpointBase}/api/public/bridallive${path}`;
    const state = {
      init: null, type: null, date: null, slot: null, contact: null, contactId: null, draftId: null,
      calStart: todayIso(), days: [], slots: [], stripe: null, cardElement: null, paymentIntentId: null, appointmentId: null,
    };
    const els = {
      loading: $("[data-beb-loading]", root),
      steps: [1, 2, 3, 4, 5].map((n) => $(`[data-beb-step="${n}"]`, root)),
      step1: $('[data-beb-step="1"]', root), step2: $('[data-beb-step="2"]', root), step3: $('[data-beb-step="3"]', root),
      step4: $('[data-beb-step="4"]', root), step5: $('[data-beb-step="5"]', root),
      typesContainer: $("[data-beb-types]", root), step1Actions: $("[data-beb-step1-actions]", root), next1: $("[data-beb-next-1]", root),
      chosen: $("[data-beb-chosen]", root),
      calRange: $("[data-beb-cal-range]", root), calDays: $("[data-beb-cal-days]", root), calPrev: $("[data-beb-cal-prev]", root), calNext: $("[data-beb-cal-next]", root),
      step3Summary: $("[data-beb-step3-summary]", root), slotsWrap: $("[data-beb-slots-wrap]", root), slotsHeading: $("[data-beb-slots-heading]", root), slotsList: $("[data-beb-slots]", root),
      summary: $("[data-beb-summary]", root), payment: $("[data-beb-payment]", root), paymentCopy: $("[data-beb-payment-copy]", root),
      stripeMount: $("[data-beb-stripe-mount]", root), stripeError: $("[data-beb-stripe-error]", root),
      agreement: $("[data-beb-agreement]", root), agreementCheck: $("[data-beb-agreement-check]", root), agreementText: $("[data-beb-agreement-text]", root),
      confirmationCopy: $("[data-beb-confirmation-copy]", root), confirmationDetail: $("[data-beb-confirmation-detail]", root),
      resume: $("[data-beb-resume]", root), resumeCopy: $("[data-beb-resume-copy]", root), resumeContinue: $("[data-beb-resume-continue]", root), resumeRestart: $("[data-beb-resume-restart]", root),
      backButtons: $$("[data-beb-back]", root),
    };
    const eventDateInput = $('input[name="event_date"]', els.step2);
    if (eventDateInput) eventDateInput.min = todayIso();

    fetch(api("/init"), { credentials: "omit" })
      .then((r) => r.json())
      .then((data) => {
        if (!data.ok) throw new Error(data.detail || "init failed");
        state.init = data;
        els.loading.hidden = true;
        renderTypes();
        start();
      })
      .catch((err) => {
        els.loading.innerHTML = `<p>Sorry, we couldn't load availability. Please call the boutique on
           <a href="tel:+61452201666">0452 201 666</a> to book.</p>`;
        console.error("[beb] init failed", err);
      });

    // Entry: a resumable draft, a deep-linked type, or a fresh step 1.
    function start() {
      const draft = loadDraft();
      const q = new URLSearchParams(location.search);
      const linked = findType(q.get("type"));
      if (draft && draft.contact && draft.contact.first_name) {
        state.draftId = draft.id;
        const t = state.init.appointment_types.find((x) => x.id === draft.type_id);
        els.resumeCopy.textContent = `Welcome back, ${draft.contact.first_name}. You started booking${t ? " a " + friendlyName(t.description) : ""} on ${new Date(draft.ts).toLocaleDateString("en-AU", { day: "numeric", month: "long" })}.`;
        els.resume.hidden = false;
        els.resumeContinue.addEventListener("click", () => { els.resume.hidden = true; resumeDraft(draft); }, { once: true });
        els.resumeRestart.addEventListener("click", () => { els.resume.hidden = true; clearDraft(); state.draftId = newDraftId(); showTypes(linked); }, { once: true });
        showTypes(null, true);
        return;
      }
      state.draftId = (draft && draft.id) || newDraftId();
      showTypes(linked);
    }
    function showTypes(preselected, quiet) {
      goToStep(1, quiet);
      if (preselected) selectType(preselected, true);
    }
    function resumeDraft(draft) {
      const t = state.init.appointment_types.find((x) => x.id === draft.type_id);
      if (draft.contact) fillContact(draft.contact);
      if (!t) { goToStep(1); return; }
      selectType(t, false);
      state.contact = draft.contact || null;
      state.contactId = draft.contact_id || null;
      if (draft.selected_date && draft.selected_date >= todayIso()) { state.date = draft.selected_date; state.calStart = draft.selected_date; }
      if (state.contact && state.contactId) { goToStep(3); loadCalendar(); }
      else goToStep(2);
    }
    function findType(hint) {
      if (!hint || !state.init) return null;
      const h = String(hint).toLowerCase();
      return state.init.appointment_types.filter((t) => t.book_online).find((t) => String(t.id) === h || friendlyName(t.description).toLowerCase().split(" ")[0] === h.split(" ")[0]) || null;
    }

    // ---------- step 1: appointment type ----------
    function friendlyName(raw) {
      const s = (raw || "").toLowerCase();
      return s.includes("first") ? "First Visit" : s.includes("third") ? "Final Visit" : s.includes("second") ? "Second Visit" : s.includes("alteration") ? "Alterations Fitting" : s.includes("return") ? "Return Visit" : cleanName(raw);
    }
    function shortDesc(raw) {
      const s = (raw || "").trim();
      if (!s) return "";
      const firstSentence = s.split(/(?<=[.!?])\s+/)[0] || s, words = firstSentence.split(/\s+/);
      return words.length > 25 ? words.slice(0, 25).join(" ") + "…" : firstSentence;
    }
    function feeLabel(t) {
      if (!t.require_payment) return "Complimentary";
      const amt = t.payment_amount || t.online_payment_amount || t.deposit_amount || { 76171: 60, 76215: 30, 76263: 90 }[t.id];
      return amt ? `$${parseFloat(amt).toFixed(0)} booking fee` : "Booking fee";
    }
    function renderTypes() {
      els.typesContainer.innerHTML = "";
      state.init.appointment_types.filter((t) => t.book_online).forEach((t) => {
        const label = document.createElement("label");
        label.className = "beb-type";
        label.dataset.typeId = t.id;
        const dur = t.duration_minutes ? `${t.duration_minutes} min` : "";
        label.innerHTML = `
            <input type="radio" name="appointment_type" value="${t.id}">
            <span class="beb-type__tick" aria-hidden="true">✓</span>
            <div class="beb-type__title">
              <h3 class="beb-type__name">${escapeHtml(friendlyName(t.description))}</h3>
              <span class="beb-type__meta">${dur}</span>
            </div>
            <div class="beb-type__fee">${escapeHtml(feeLabel(t))}</div>
            <p class="beb-type__desc">${escapeHtml(shortDesc(t.online_description))}</p>
            <span class="beb-type__cta" aria-hidden="true">Select →</span>
          `;
        els.typesContainer.appendChild(label);
      });
      els.typesContainer.addEventListener("change", (e) => {
        if (e.target.name !== "appointment_type") return;
        const t = state.init.appointment_types.find((x) => x.id === parseInt(e.target.value, 10));
        if (t) selectType(t, true);
      });
      els.next1.addEventListener("click", () => { if (state.type) advanceFromType(); else showError(els.step1, "Please choose an appointment to continue."); });
    }
    function selectType(t, advance) {
      state.type = t;
      $$(".beb-type", els.typesContainer).forEach((l) => {
        const on = parseInt(l.dataset.typeId, 10) === t.id;
        l.classList.toggle("is-selected", on);
        const r = l.querySelector("input");
        if (r) r.checked = on;
      });
      els.step1Actions.hidden = false;
      saveDraft({ type_id: t.id });
      if (advance) { beacon("type"); setTimeout(advanceFromType, 320); }
    }
    function advanceFromType() {
      clearError(els.step1);
      els.chosen.innerHTML = `${escapeHtml(friendlyName(state.type.description))} <span class="beb-chosen__meta">\xB7 ${state.type.duration_minutes || ""} min \xB7 ${escapeHtml(feeLabel(state.type))}</span>`;
      goToStep(2);
      const first = $('input[name="first_name"]', els.step2);
      if (first && !first.value && window.matchMedia("(min-width: 750px)").matches) first.focus({ preventScroll: true });
    }

    // ---------- step 2: your details ----------
    function fillContact(c) {
      ["first_name", "last_name", "email", "mobile", "event_date"].forEach((k) => {
        const i = $(`[name="${k}"]`, els.step2);
        if (i && c[k]) i.value = c[k];
      });
    }
    els.step2.addEventListener("submit", (e) => {
      e.preventDefault();
      const fd = new FormData(els.step2);
      if ((fd.get("honeypot") || "").toString().trim()) return;
      if (!state.type) { goToStep(1); return; }
      const contact = {
        first_name: (fd.get("first_name") || "").toString().trim(),
        last_name: (fd.get("last_name") || "").toString().trim(),
        email: (fd.get("email") || "").toString().trim(),
        mobile: (fd.get("mobile") || "").toString().trim(),
        event_date: (fd.get("event_date") || "").toString().trim() || null,
      };
      clearFieldErrors();
      const problems = validateContact(contact);
      if (problems.length) { problems.forEach((p) => showFieldError(p.field, p.msg)); focusField(problems[0].field); return; }
      const unchanged = state.contactId && state.contact && JSON.stringify(state.contact) === JSON.stringify(contact);
      state.contact = contact;
      clearError(els.step2);
      saveDraft({ contact: contact, type_id: state.type.id });
      // Same details as the contact BridalLive already holds (she went back and forward): do not create a duplicate.
      if (unchanged) { goToStep(3); loadCalendar(); return; }
      state.contactId = null;
      fetch(api("/contact"), {
        method: "POST", headers: { "Content-Type": "application/json" }, credentials: "omit",
        body: JSON.stringify(Object.assign({}, contact, { source: "shopify-appointment-form-step1", honeypot: "", attribution: bebAttribution(), draft_id: state.draftId, type_id: state.type.id })),
      }).then((r) => r.json()).then((d) => {
        if (d && d.contact_id) { state.contactId = d.contact_id; saveDraft({ contact_id: d.contact_id }); }
        beacon("details");
      }).catch(() => { beacon("details"); });
      goToStep(3);
      loadCalendar();
    });
    // Clear a field's error as soon as the bride edits it.
    $$("input", els.step2).forEach((i) => i.addEventListener("input", () => { const f = i.closest("[data-beb-field]"); if (f) setFieldError(f, ""); }));

    // ---------- step 3: date + time ----------
    els.calPrev.addEventListener("click", () => { state.calStart = isoAdd(state.calStart, -14); if (state.calStart < todayIso()) state.calStart = todayIso(); loadCalendar(); });
    els.calNext.addEventListener("click", () => { state.calStart = isoAdd(state.calStart, 14); loadCalendar(); });
    function loadCalendar() {
      els.step3Summary.textContent = `${friendlyName(state.type.description)} for ${state.contact ? state.contact.first_name : "you"}`;
      const start = state.calStart, end = isoAdd(start, 13);
      els.calRange.textContent = `${fmtMonth(start)} to ${fmtMonth(end)}`;
      els.calDays.innerHTML = '<li style="grid-column:1/-1;color:var(--beb-muted);font-size:.85rem;">Loading…</li>';
      beacon("calendar");
      fetch(api(`/availability/range?type_id=${state.type.id}&start=${start}&end=${end}`), { credentials: "omit" })
        .then((r) => r.json())
        .then((data) => {
          if (!data.ok) throw new Error("range failed");
          state.days = data.days;
          renderDays();
          if (state.date && state.days.some((d) => d.date === state.date && d.available && d.slot_count > 0)) {
            const b = $(`.beb-cal-day[data-date="${state.date}"]`, els.calDays);
            if (b) b.classList.add("is-selected");
            loadSlots();
          }
        })
        .catch((err) => {
          console.error("[beb] range failed", err);
          els.calDays.innerHTML = `<li style="grid-column:1/-1;color:var(--beb-error);">Couldn't load dates. Please refresh or call the boutique.</li>`;
        });
    }
    function renderDays() {
      els.calDays.innerHTML = "";
      state.days.forEach((d) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "beb-cal-day";
        btn.dataset.date = d.date;
        if (!(d.available && !d.blacked_out && d.slot_count > 0)) btn.disabled = true;
        btn.innerHTML = `<span class="beb-cal-day__dow">${fmtDow(d.date)}</span>${fmtDay(d.date)}`;
        btn.addEventListener("click", () => {
          $$(".beb-cal-day", els.calDays).forEach((b) => b.classList.remove("is-selected"));
          btn.classList.add("is-selected");
          state.date = d.date;
          saveDraft({ selected_date: d.date });
          beacon("date");
          loadSlots();
        });
        const li = document.createElement("li");
        li.appendChild(btn);
        els.calDays.appendChild(li);
      });
    }
    function loadSlots() {
      els.slotsWrap.hidden = false;
      els.slotsHeading.textContent = fmtDateLong(state.date);
      els.slotsList.innerHTML = '<li style="grid-column:1/-1;color:var(--beb-muted);font-size:.85rem;">Loading…</li>';
      fetch(api(`/availability?type_id=${state.type.id}&date=${state.date}`), { credentials: "omit" })
        .then((r) => r.json())
        .then((data) => {
          if (!data.ok) throw new Error("availability failed");
          state.slots = data.slots;
          renderSlots();
          els.slotsWrap.scrollIntoView({ behavior: "smooth", block: "nearest" });
        })
        .catch((err) => {
          console.error("[beb] availability failed", err);
          els.slotsList.innerHTML = `<li style="grid-column:1/-1;color:var(--beb-error);">Couldn't load times.</li>`;
        });
    }
    function renderSlots() {
      els.slotsList.innerHTML = "";
      if (!state.slots.length) {
        els.slotsList.innerHTML = '<li style="grid-column:1/-1;color:var(--beb-muted);">No available times on this date, please pick another.</li>';
        return;
      }
      state.slots.forEach((s) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "beb-slot";
        btn.textContent = fmtTime(s.start_ms);
        btn.addEventListener("click", () => {
          state.slot = s;
          beacon("slot");
          goToStep(4);
          renderSummary();
        });
        const li = document.createElement("li");
        li.appendChild(btn);
        els.slotsList.appendChild(li);
      });
    }

    // ---------- step 4: confirm ----------
    function renderSummary() {
      els.summary.innerHTML = `
        <dt>Appointment</dt><dd>${escapeHtml(cleanName(state.type.description))}</dd>
        <dt>Date</dt><dd>${fmtDateLong(state.date)}</dd>
        <dt>Time</dt><dd>${fmtTime(state.slot.start_ms)} (${state.type.duration_minutes} min)</dd>
        <dt>Name</dt><dd>${escapeHtml(state.contact.first_name)} ${escapeHtml(state.contact.last_name)}</dd>
        <dt>Email</dt><dd>${escapeHtml(state.contact.email)}</dd>
        <dt>Mobile</dt><dd>${escapeHtml(state.contact.mobile)}</dd>
      `;
      if (state.type.require_payment) {
        els.payment.hidden = false;
        els.agreement.hidden = false;
        els.paymentCopy.textContent = "A non-refundable booking fee secures this appointment. Please enter your card details below, we'll process the fee once you confirm.";
        els.agreementText.textContent = state.init.agreements.booking || "I agree to the booking terms.";
        mountStripe();
        beacon("payment");
      } else {
        els.payment.hidden = true;
        els.agreement.hidden = true;
      }
    }
    function mountStripe() {
      if (state.cardElement) return;
      const pk = state.init.payment.stripe_publishable;
      if (!pk || !window.Stripe) {
        els.stripeError.hidden = false;
        els.stripeError.textContent = "Payment unavailable. Please call the boutique on 0452 201 666.";
        return;
      }
      state.stripe = window.Stripe(pk);
      const elements = state.stripe.elements();
      state.cardElement = elements.create("card", { style: { base: { fontFamily: '"Inter", system-ui, sans-serif', fontSize: "15px", color: "#1a1a1a", "::placeholder": { color: "#888" } } } });
      state.cardElement.mount(els.stripeMount);
      state.cardElement.on("change", (ev) => {
        els.stripeError.hidden = !ev.error;
        if (ev.error) els.stripeError.textContent = ev.error.message;
      });
    }
    els.step4.addEventListener("submit", async (e) => {
      e.preventDefault();
      const fd = new FormData(els.step4);
      if ((fd.get("honeypot") || "").toString().trim()) return;
      const submitBtn = $("[data-beb-submit]", els.step4), comments = (fd.get("comments") || "").toString().trim();
      const unlock = () => { submitBtn.classList.remove("is-loading"); submitBtn.disabled = false; };
      if (state.type.require_payment) {
        if (!els.agreementCheck.checked) return showError(els.step4, "Please accept the booking agreement to continue.");
        if (!state.cardElement) return showError(els.step4, "Card form not loaded. Please refresh.");
        submitBtn.classList.add("is-loading");
        submitBtn.disabled = true;
        let dep;
        try {
          const dr = await fetch(api("/deposit-intent"), {
            method: "POST", headers: { "Content-Type": "application/json" }, credentials: "omit",
            body: JSON.stringify({ type_id: state.type.id, slot_start_ms: state.slot.start_ms, email: state.contact.email, source: "shopify-appointment-form" }),
          });
          dep = await dr.json();
          if (!dr.ok || !dep.ok || !dep.client_secret) throw new Error((dep && dep.detail) || "Couldn't start the payment");
        } catch (err) {
          unlock();
          return showError(els.step4, err.message || "Couldn't start the payment, please try again.");
        }
        const { paymentIntent, error } = await state.stripe.confirmCardPayment(dep.client_secret, {
          payment_method: { card: state.cardElement, billing_details: { name: `${state.contact.first_name} ${state.contact.last_name}`, email: state.contact.email, phone: state.contact.mobile } },
        });
        if (error) { unlock(); return showError(els.step4, error.message); }
        if (!paymentIntent || paymentIntent.status !== "succeeded") { unlock(); return showError(els.step4, "Payment was not completed. Please try again or call the boutique on 0452 201 666."); }
        state.paymentIntentId = paymentIntent.id;
      } else {
        submitBtn.classList.add("is-loading");
        submitBtn.disabled = true;
      }
      const body = {
        type_id: state.type.id, slot_start_ms: state.slot.start_ms, fitting_room_id: state.slot.fitting_room_id,
        first_name: state.contact.first_name, last_name: state.contact.last_name, email: state.contact.email, mobile: state.contact.mobile,
        event_date: state.contact.event_date, comments: comments || null, honeypot: "",
        selected_date: state.date || null, duration_ms: (state.slot && state.slot.duration_ms) || null,
        draft_id: state.draftId,
      };
      if (state.type.require_payment) { body.payment_intent_id = state.paymentIntentId; body.agreement_accepted = true; }
      body.attribution = bebAttribution();
      try {
        const resp = await fetch(api("/appointment"), { method: "POST", headers: { "Content-Type": "application/json" }, credentials: "omit", body: JSON.stringify(body) });
        const data = await resp.json();
        if (!resp.ok || !data.ok) {
          const msg = data && data.detail && data.detail.errors ? Object.entries(data.detail.errors).map(([k, v]) => `${k}: ${v}`).join(", ") : data.detail || "Booking failed";
          throw new Error(msg);
        }
        els.confirmationCopy.textContent = data.dry_run ? "(test mode, no real booking created)" : "";
        els.confirmationDetail.textContent = `${friendlyName(state.type.description)}, ${fmtDateLong(state.date)} at ${fmtTime(state.slot.start_ms)}.`;
        state.appointmentId = data.appointment_id || null;
        beacon("confirmed", { appointment_id: state.appointmentId });
        saveDraft({ done: true });
        clearDraft();
        fireConfirmationAnalytics();
        goToStep(5);
      } catch (err) {
        console.error("[beb] appointment submit failed", err);
        beacon("error");
        showError(els.step4, err.message || "Sorry, booking failed. Please try again or call the boutique.");
      } finally {
        unlock();
      }
    });
    els.backButtons.forEach((btn) => btn.addEventListener("click", () => goToStep(parseInt(btn.dataset.bebBack, 10))));

    // ---------- navigation ----------
    function goToStep(n, quiet) {
      els.steps.forEach((s, i) => { if (s) s.hidden = i + 1 !== n; });
      const visible = els.steps[n - 1];
      if (visible) clearError(visible);
      const progressN = Math.min(n, 4);
      $$(".beb-progress__step", root).forEach((li) => {
        const i = parseInt(li.dataset.step, 10);
        li.classList.toggle("is-active", i === progressN);
        li.classList.toggle("is-done", i < progressN);
      });
      const progress = root.querySelector("[data-beb-progress]");
      if (progress) progress.hidden = n >= 5;
      if (!quiet) root.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    // ---------- analytics on confirmation (unchanged) ----------
    function fireConfirmationAnalytics() {
      const bebId = state.appointmentId ? "beb_appt_" + state.appointmentId : "beb_" + Date.now();
      const bebType = (state.type && state.type.description) || "";
      const bebFee = (state.type && Number(state.type.payment_amount || 0)) || 0;
      try { window.__attributable && window.__attributable("trackStructEvent", { category: "booking", action: "confirmed", label: bebId, property: bebType, value: bebFee }); } catch (e) {}
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "beb_booking_confirmed", beb_booking_id: bebId, beb_booking_type: bebType, beb_booking_value: bebFee, beb_currency: "AUD" });
        if (window.gtag) {
          window.gtag("event", "bookedappointment_121", { event_category: "engagement", event_label: "Appointment Booked", value: 1 });
          window.gtag("event", "conversion", { send_to: "AW-980681985/SJdFCKqAkIUcEIGK0NMD", value: 1, currency: "AUD", transaction_id: bebId });
        }
        if (window.fbq) {
          window.fbq("track", "Lead", { value: 1, currency: "AUD" }, { eventID: bebId });
          window.fbq("trackCustom", "bookedappointment_121", { value: 1, currency: "AUD" }, { eventID: bebId });
        }
        if (window.pintrk) window.pintrk("track", "lead", { lead_type: "Appointment" });
      } catch (e) { console.warn("[beb] analytics fire failed", e); }
    }

    // ---------- validation + errors ----------
    function validateContact(c) {
      const out = [];
      if (!c.first_name) out.push({ field: "first_name", msg: "Please enter your first name." });
      if (!c.last_name) out.push({ field: "last_name", msg: "Please enter your last name." });
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(c.email)) out.push({ field: "email", msg: "Please enter a valid email address." });
      const phone = c.mobile.replace(/[\s\-()]/g, "");
      if (!/^(\+?61|0)4\d{8}$/.test(phone)) out.push({ field: "mobile", msg: "Please enter an Australian mobile number (e.g. 04xx xxx xxx)." });
      if (!c.event_date || !/^\d{4}-\d{2}-\d{2}$/.test(c.event_date)) out.push({ field: "event_date", msg: "Please enter your wedding date, an approximate date is fine." });
      return out;
    }
    function fieldEl(name) { return $(`[data-beb-field="${name}"]`, els.step2); }
    function setFieldError(f, msg) {
      const err = f.querySelector("[data-beb-field-err]"), input = f.querySelector("input");
      f.classList.toggle("is-invalid", !!msg);
      if (input) input.setAttribute("aria-invalid", msg ? "true" : "false");
      if (err) { err.textContent = msg; err.hidden = !msg; }
    }
    function showFieldError(name, msg) { const f = fieldEl(name); if (f) setFieldError(f, msg); }
    function clearFieldErrors() { $$("[data-beb-field]", els.step2).forEach((f) => setFieldError(f, "")); }
    function focusField(name) {
      const f = fieldEl(name), input = f && f.querySelector("input");
      if (!input) return;
      f.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(() => input.focus({ preventScroll: true }), 250);
    }
    function showError(stepEl, msg) {
      const el = stepEl.querySelector("[data-beb-error]");
      if (el) { el.textContent = msg; el.hidden = false; el.scrollIntoView({ behavior: "smooth", block: "nearest" }); }
    }
    function clearError(stepEl) {
      const el = stepEl.querySelector("[data-beb-error]");
      if (el) { el.hidden = true; el.textContent = ""; }
    }
    function escapeHtml(s) {
      return String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
    }
  }
})();
